import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { GeorefApiService } from './georef-api.service';

@Injectable({
	providedIn: 'root',
})
export class ParametricasService {
	constructor(private _apiService: ApiService, private _georefApiServices: GeorefApiService) {}

	/* GET */
	getClasesModalidades(tipoLista: string) {
		return this._apiService.get(`/clasesModalidad`, { tipoLista: tipoLista });
	}

	getModalidadesPrestacion() {
		return this._apiService.get(`/modalidadesPrestacion`);
	}

	getPaises(params: Object = { limit: 250 }, absolutePath = false) {
		return this._georefApiServices.get(`/paises`, params, absolutePath);
	}

	getProvincias(params: Object = {}, absolutePath = false) {
		return this._georefApiServices.get(`/provincias`, params, absolutePath);
	}

	getLocalidades(params: Object = {}, absolutePath = false) {
		return this._georefApiServices.get(`/localidades`, params, absolutePath);
	}

	getTiposDocumentos() {
		return this._apiService.get(`/tiposDocumento`);
	}

	getServerDateTime() {
		return this._apiService.get(`/public/serverDateTime`);
	}

	getClaseModalidadModalidadPrestacion(claseModalidadId: string = '', modalidadPrestacionId: string = '') {
		return this._apiService.get(`/modalidadesPrestacion/claseModalidadModalidadPrestacion`, {
			claseModalidadId: claseModalidadId,
			modalidadPrestacionId: modalidadPrestacionId,
		});
	}

	getClaseModalidadModalidadOperador(claseModalidadId: string = '', seopClaseModalidadAbrev: string = '') {
		return this._apiService.get(`/clasesModalidad/claseModalidadModalidadOperador`, {
			claseModalidadId: claseModalidadId,
			seopClaseModalidadAbrev: seopClaseModalidadAbrev,
		});
	}

	getClaseModalidadPais(claseModalidadId: string = '') {
		return this._apiService.get(`/pais/claseModalidadPais`, {
			claseModalidadId: claseModalidadId,
		});
	}

	getMotivosAuxilio() {
		return this._apiService.get(`/motivosAuxilio`);
	}

	getPaisesTransito(params: Object = {}) {
		return this._apiService.get(`/paisestransito`, params);
	}

	getPasosFronterizos(params: Object = {}) {
		return this._georefApiServices.get(`/pasosFronterizos`, params);
	}
}
